interface Props {
  children?: React.ReactNode;
}

export const DetailTableHeaderLeft: React.FC<Props> = ({ children }) => {
  return (
    <th
      scope="col"
      className="py-3.5 pl-6 pr-3 lg:text-sm md:text-sm text-xs font-semibold text-left text-gray-900"
    >
      {children}
    </th>
  );
};
